import * as React from 'react'
import { useSelector } from 'react-redux'
import * as CSS from 'csstype'
import { Button, Form, Container, Spinner } from 'react-bootstrap'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useRouteMatch,
  useParams, useHistory
} from 'react-router-dom'

import {  AxiosInstance } from '../../utils/RequestMethods'

import config from '../../constants/config'
import iconsMarkers from '../../constants/iconsMarkers'
import images from '../../constants/images'
import MapBoxView from '../../components/MapBoxView'
import Pagination from "react-js-pagination";
import './workers.css'
import { WorkerT } from '../../types/Worker'
import TableBootstrap from '../../components/TableBootstrap/TableBootstrap'
import { TdLink } from '../../components/TableBootstrap/TdLink'
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner'
import { IAppState } from '../../redux/reducers'
import { phoneFormat } from '../../utils'
import GoogleMapView from '../../components/MapView/GoogleMapView'
const initialCoords = {
  latitude: Number(config.coords.lat),
  longitude: Number(config.coords.long)
}
interface WorkersProps {

}

const ConfigPagination = {
  PerPage: 50,
  pageRangeDisplayed: 10
}


const WorkersPage: React.FunctionComponent<WorkersProps> = ({ }) => {
  let match = useRouteMatch()
  let { page } = useParams()
  const auth = useSelector((state: IAppState) => state.auth)
  const history = useHistory()
  const [markers, setMarkers] = React.useState([])

  const [workers, setWorkers] = React.useState([])
  const [loading, setLoading] = React.useState(false)
  let [coords, setCoords] = React.useState(initialCoords)
  const [paginationInfo, setPaginationInfo] = React.useState({
    activePage: 1,
    itemsCountPerPage: ConfigPagination.PerPage,
    totalPages: 0,
    pageRangeDisplayed: ConfigPagination.pageRangeDisplayed,
    total: 0,

  })
  React.useEffect(() => {
    let activePage = page ? page : 1

    setPaginationInfo({
      ...paginationInfo, ...{
        activePage: activePage
      }
    })
    setWorkersFromDb("", activePage)


  }, [page])

  React.useEffect((): void => {
    if (auth.userData.addressDetails) {
      setCoords({
        latitude: Number(auth.userData.addressDetails.latitude),
        longitude: Number(auth.userData.addressDetails.longitude)
      })
    }

  }, [auth.userData.addressDetails])
  const addWorker = (): void => {
    history.push({
      pathname: '/workers/new-worker'
    })
  }
  /**
    *
    * @param page
    */
  const goToPage = (page) => {
    history.push({
      pathname: `${getBaseUrl(match)}/${page}`
    })
  }

  /**
   *
   * @param match
   */
  const getBaseUrl = (match) => {
    let url = match.url
    return url.replace(/\/[0-9]+$/g, '');
  }
  /**
  *
  * @param worker
  */
  const generateBaseUrl = (worker: WorkerT) => {
    return `/worker/${worker.id}`
  }


  const openWorker = (worker: WorkerT): void => {
    history.push({
      pathname: `/worker/${worker.id}`
    })
  }

  const renderWorkers = (): Array<JSX.Element> => {
    return workers.map((worker, index) => {
      return (
        <div className='wRow wRowBody' key={index} onClick={() => { openWorker(worker) }}>
          <span>
            <p>{worker.firstName} {worker.lastName}</p>
          </span>
          <span>
            <p>{worker.phone}</p>
          </span>
          <span>
            <p>{worker.email}</p>
          </span>
        </div>
      )
    })
  }

  /**
   *
   * @param searchStr
   * @param page
   */
  const setWorkersFromDb = async (searchStr: string = "", page: number = null): Promise<void> => {
    setLoading(true)
    try {
      let params = {
        // type: "workres",
        search: searchStr,
        page: page,
        per_page: ConfigPagination.PerPage,
      }
      let options = {
        data: params
      }

      AxiosInstance.get(config.url.workers, options).then(res => {
        setLoading(false)
        if (res && res.headers && res.headers['x-wp-totalpages']) {
          const total = res.headers['x-wp-total']
          const totalPages = res.headers['x-wp-totalpages']
          setPaginationInfo((draft) => {
            draft.total = total
            draft.totalPages = totalPages
            draft.activePage = page
            return draft
          })
        }
        if (res && res.data) {
          // @ts-ignore
          setWorkers([...res.data])
          updateMarkers(res.data)

        }

      })
    } catch (error) {
      console.log('setWorkersFromDb', error)
      setLoading(false)

    }
  }

  const updateMarkers = (workers: Array<WorkerT>): void => {
    const markersColors = iconsMarkers.users.colors
    let markers = []
    workers.map((item: WorkerT, index) => {
      if (item.location) {
        let imageBg = markersColors['worker']
        let marker = {
          coordinate: {
            latitude: Number(item.location.latitude),
            longitude: Number(item.location.longitude),
          },
          bgImage: imageBg,
          pinImage: images["worker-white"],
          id: index,
        }
        markers.push(marker)
      }
    })
    setMarkers(markers)
  }

  /**
   *
   * @returns
   */
  const renderSectionPagination = (): JSX.Element => {
    return (
      <div className="d-flex flex-row">
        <div className=" p-2 ">
          <Pagination
            hideFirstLastPages={true}
            firstPageText="First"
            lastPageText="Last"

            prevPageText="&lt; Prev"

            nextPageText="Next &gt;"
            linkClass="page-link"
            itemClass="page-item"
            activePage={Number(paginationInfo.activePage)}
            itemsCountPerPage={paginationInfo.itemsCountPerPage}
            totalItemsCount={Number(paginationInfo.total)}
            pageRangeDisplayed={paginationInfo.pageRangeDisplayed}
            onChange={(page) => {
              goToPage(page)
            }}
            getPageUrl={(i) => {
              return `${getBaseUrl(match)}/${i}`
            }}
          />

        </div>
        <div>


          <Button
            onClick={addWorker}
            variant='success'>
            Add Worker
          </Button>
        </div>
      </div>
    )
  }


  return (
    <Container fluid className="mt-2 mb-5">
      <div style={{ position: "relative" }} className="p-1 pr-3">
        <GoogleMapView
          // mapboxApiAccessToken={config.keyMapBox}
          coordinate={coords}
          markers={markers} />
      </div>
      {renderSectionPagination()}

      <LoadingSpinner loading={loading}>
        <TableBootstrap<WorkerT>
          columns={['Name', 'Phone', 'Email']}
          data={workers}
          // customRenderColumn={customRenderColumn}
          onClickItem={(item) => {
            openWorker(item)
          }}

          renderRowItem={(worker, index) => {
            const to = generateBaseUrl(worker)

            return (
              <>
                <TdLink to={`${to}`}> {worker.firstName} {worker.lastName} </TdLink>
                <TdLink to={`${to}`}> {phoneFormat(worker.phone)} </TdLink>
                <TdLink to={`${to}`}> {worker.email}  </TdLink>
                {/* <TdLink to={to}>{job.scheduledDate}</TdLink> */}
              </>
            )
          }} />
      </LoadingSpinner>
      {renderSectionPagination()}
    </Container>
  )
}

const Workers: React.FC<{}> = ({ }) => {
  let match = useRouteMatch();
  return (
    <Switch>
      <Route path={`${match.path}/:page`}>
        <WorkersPage />
      </Route>
      <Route path={match.path}>
        <WorkersPage />
      </Route>
    </Switch>
  )
}
export default Workers
